import { render } from "./FilterSmallRange.vue?vue&type=template&id=35a6c21c&ts=true"
import script from "./FilterSmallRange.vue?vue&type=script&lang=ts"
export * from "./FilterSmallRange.vue?vue&type=script&lang=ts"

import "./FilterSmallRange.vue?vue&type=style&index=0&id=35a6c21c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__